export default function Logo() {
  return (
    <div className="flex items-center gap-2">
      <div className="bg-accent h-6 w-6 rounded-full" />
      <span className="text-primary inline-block font-serif text-[1.5rem] leading-none">
        ACRI
      </span>
    </div>
  )
}
